/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Category_ConsolesInputs */

const he_home_category_consoles = /** @type {(inputs: Home_Category_ConsolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קונסולות`)
};

const en_home_category_consoles = /** @type {(inputs: Home_Category_ConsolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game Consoles`)
};

/**
* | output |
* | --- |
* | "Game Consoles" |
*
* @param {Home_Category_ConsolesInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_category_consoles = /** @type {((inputs?: Home_Category_ConsolesInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Category_ConsolesInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_category_consoles(inputs)
	return en_home_category_consoles(inputs)
});